export const iconFontAwesomeNatureMountainSun = (
	<i className="fa-solid fa-mountain-sun"></i>
);
